import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { BackArrowHistory as BackArrow } from 'components/navigation/back-arrow';
import { brandFont } from 'styles/brand-font';

export const BackButtonContainer = styled.div`
  background-color: ${Styles.color.cardBackground};
  padding-block-start: 1rem;
  padding-block-end: 0;
  padding-inline: 1rem;
`;

export const StyledBackButton = styled(ActionButton)`
  & > span {
    font: ${brandFont.copyTwo};
  }
`;

export const StyledBackArrow = styled(BackArrow)`
  inset-block-start: calc(3px + env(safe-area-inset-top) - ${Styles.layout.navHeight.mobile});
`;
